import { render, staticRenderFns } from "./VenueManagementList.vue?vue&type=template&id=668b21a8&scoped=true&"
import script from "./VenueManagementList.vue?vue&type=script&lang=js&"
export * from "./VenueManagementList.vue?vue&type=script&lang=js&"
import style0 from "./VenueManagementList.vue?vue&type=style&index=0&id=668b21a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b21a8",
  null
  
)

export default component.exports